import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { FormGroup } from 'reactstrap';
import { ValidableFeedback } from '@ami/react/core';

export default class ProductNotes extends React.PureComponent {
  static propTypes = {
    notes: PropTypes.string,
    notesField: PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      isRequired: PropTypes.bool.isRequired,
    }),
    onNotesChange: PropTypes.func.isRequired,
  };

  render() {
    const { notes, notesField, onNotesChange } = this.props;
    if (!notesField) {
      return null;
    }
    const invalid = notesField.isRequired && !notes;
    return (
      <div>
        <FormGroup className={`option-set-form ${invalid && 'invalid'}`}>
          <div className="row">
            <div className="col">
              <div className="optionset-name">{notesField.name}</div>
              <ValidableFeedback
                invalid={invalid}
                text="Please enter some notes"
              />
              <div className="optionset-description">
                {notesField.description}
              </div>
            </div>
          </div>
          <div className="mt-3">
            <Input
              placeholder={notesField.name}
              value={notes}
              onChange={(e) => onNotesChange(e.target.value)}
            />
          </div>
        </FormGroup>
      </div>
    );
  }
}
